<template>
    <div id="content">
        <div class="container-fluid page-title">
            <div class="container">
                <h1>
                    Novidades
                </h1>
            </div>
        </div>
        <div class="container page-content">
            <p class="text-justify">
                No auditório do American Towers Hotel, em Salvador Bahia,
                o Programa Parceiro Simonetti, reuniu empresários da região que foram selecionados.
                Recebidos com um delicioso café, e tiveram a oportunidade de conhecer a história
                e as características da empresa e do programa.
                Ao fim da apresentação, os empresários participaram de um happy hour com música ao vivo,
                bom bate papo e diversão. Confira as fotos em nossa galeria.
                <small><i class="text-muted">Clique na imagem para ampliar.</i></small>
            </p>
            <img class="image-viewer-click rounded" style="margin-right: 7px; margin-bottom: 7px;" v-img="{group: 'novidades', src: source.path}" v-for="source in images" :src="source.thumb_url" :key="source.id">
        </div>
    </div>
</template>
<style>
    .image-viewer-click:hover {
        cursor: pointer;
    }
</style>

<script>
    import axios from "axios"

    export default {
        data: () => ({
            images: null
        }),
        methods: {
            loadImages() {
                axios.get('api/media/novidades')
                    .then(response => {
                        this.images = response.data
                    })
                    .catch(e => {
                        this.errors.push(e)
                    });
            }

        },
        created: function () {
            this.loadImages()
        }
    }
</script>



// WEBPACK FOOTER //
// Novidades.vue?5c1250d8